import React from 'react';
import Colors from '../constants/Colors';
import Firestore from '../api/firebase/Firestore';
import SessionHelper from '../helper/SessionHelper';
import ClipLoader from "react-spinners/ClipLoader";

export default class StudentSubscriptionStatus extends React.Component {

    state = {
        loading: false,
        status: null,
    }

    async componentDidMount() {

        await this.setState({ loading: true });
        await this.getSubscriptionStatus();

        this.setState({ loading: false });
    }

    async componentDidUpdate(prev) {

        if (this.props.user !== prev.user) {

            await this.setState({ loading: true });
            await this.getSubscriptionStatus();
    
            this.setState({ loading: false });
        }
    }

    async getSubscriptionStatus() {

        let query = await Firestore.customQuery('student_subscription').where('id_user', '==', this.props.user).where('id_company', '==', SessionHelper.getData().id_company).orderBy('created_at', 'desc').limit(1).get();

        if (query.size === 1) {

            let doc = query.docs[0].data();

            this.setState({ status: doc.status });
        }
    }

    renderLoading() {

        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ClipLoader
                size={25}
                color={Colors.primary}
                loading={true}
                />
            </div>
        )
    }

    renderSubscriptionStatus(status) {

        let text;
        let color;

        if (status === 'paid') {

            text = 'Pagamento em dia';
            color = Colors.success;

        } else if (status === 'trialing') {

            text = 'Período Gratuíto';
            color = Colors.danger;

        } else if (status === 'canceled') {

            text = 'Cancelado';
            color = Colors.error;

        } else if (status === 'ended') {

            text = 'Encerrado';
            color = Colors.success;

        } else if (status === 'pending_payment') {

            text = 'Aguardando Pagamento';
            color = Colors.danger;

        } else if (status === 'unpaid') {

            text = 'Inadimplente';
            color = Colors.error;

        } else {

            text = 'Sem Matrícula';
            color = 'lightgrey';
        }

        return <b style={{ backgroundColor: color, color: 'white', paddingTop: 5, paddingBottom: 5, paddingLeft: 8, paddingRight: 8, borderRadius: 5 }}>{text}</b>
    }

    render() {

        return this.state.loading ? this.renderLoading() : (

            <div style={{ }}>
                {this.renderSubscriptionStatus(this.state.status)}
            </div>
        );
    }
}